import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import NumberFormat from 'react-number-format'
import { Button, Column, Columns, Container } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import moment from 'moment'
import PageWrapper from '../../../../internal/PageWrapper'
import successAnimation from '../../../../assets/animations/success_animated.svg'
import { getText } from '../../../../internal/TextLabels'

const cellStyle = {
  width: '28%',
  float: 'left',
  margin: '3px 0',
}

const textCellStyle = {
  width: '22%',
  float: 'left',
  textAlign: 'right',
  margin: '3px 0',
}

export const DelayedPaymentDonePage = props => {
  const getCreditAmount = () => {
    const { approvedAmount } =
      (props.data.payment &&
        props.data.payment.paymentResult &&
        props.data.payment.paymentResult.application) ||
      {}
    const { approvedCredit } = props.data.current.selectedCard || {}
    return approvedAmount || approvedCredit
  }

  const getPurchaseAmount = () => {
    const { selectedAmount } = props.data.current || {}
    const { totalOrderAmount } =
      props.data.payment.paymentResult &&
      props.data.payment.paymentResult.payment &&
      props.data.payment.paymentResult.payment.paymentStatus
    return selectedAmount || totalOrderAmount
  }

  const getAccountNumber = () => {
    const { accountNumber } = props.data.current.account
    return accountNumber
  }

  const isCustomerWithAnAccountNumber = () => {
    const { current } = props.data
    return current.account && current.account.accountNumber
  }

  const getFormattedAutomaticDebitDate = () => {
    return moment(props.data.payment.paymentResult.automaticDebitDate).format(
      'LL',
    )
  }

  return (
    <>
      <PageWrapper type="success">
        <Container>
          <Columns>
            <Column col1>
              <img
                style={{ margin: '1rem 1rem' }}
                src={successAnimation}
                alt="Success animation"
              />
            </Column>
            <Column col11>
              <h4 style={{ margin: '2.2rem 1rem 0 0' }}>
                {getText('payApply.delayedPaymentDone.title')}
              </h4>
            </Column>
            <Column col12>
              <div style={{ padding: '0 15px', width: '100%' }}>
                {isCustomerWithAnAccountNumber() && (
                  <div style={{ clear: 'both' }}>
                    <div style={cellStyle}>
                      {getText('payApply.paymentDone.accountNumber')}
                    </div>
                    <div style={textCellStyle}>
                      <NumberFormat
                        value={getAccountNumber()}
                        displayType="text"
                        format="#### #### #### ####"
                      />
                    </div>
                  </div>
                )}
                <div style={{ clear: 'both' }}>
                  <div style={cellStyle}>
                    {getText(
                      props.data.current.selectedCard &&
                        props.data.current.selectedCard.approvedCredit
                        ? 'payApply.delayedPaymentDone.existingCreditLimit'
                        : 'payApply.delayedPaymentDone.requestedCreditLimit',
                    )}
                  </div>
                  <div style={textCellStyle}>
                    <NumberFormat
                      value={getCreditAmount()}
                      displayType="text"
                      thousandSeparator=" "
                      renderText={val => getText('default.currency', val)}
                    />
                  </div>
                </div>
                <div style={{ clear: 'both' }}>
                  <div style={cellStyle}>
                    {getText('payApply.delayedPaymentDone.amount')}
                  </div>
                  <div style={textCellStyle}>
                    <NumberFormat
                      value={getPurchaseAmount()}
                      displayType="text"
                      thousandSeparator=" "
                      renderText={val => getText('default.currency', val)}
                    />
                  </div>
                </div>
                {props.data.payment.paymentResult.automaticDebitDate ? (
                  <div>
                    <div
                      style={{
                        display: 'inline-block',
                        marginTop: '50px',
                        width: '100%',
                      }}
                    >
                      {`${getText(
                        'payApply.delayedPaymentDone.instructionsAutomaticDebit1',
                      )} ${getFormattedAutomaticDebitDate()}${getText(
                        'payApply.delayedPaymentDone.instructionsAutomaticDebit2',
                      )}`}
                    </div>
                    <div
                      style={{
                        display: 'inline-block',
                        marginTop: '1.5rem',
                        width: '100%',
                        marginBottom: '1.5rem',
                      }}
                    >
                      {getText(
                        'payApply.delayedPaymentDone.instructionsAutomaticDebit3',
                      )}
                      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                      <NavLink
                        style={{
                          font: 'normal normal normal 15px/20px Arial',
                          color: '#0DBDEB',
                        }}
                        to="/payments/ongoing"
                      >
                        {getText('payApply.delayedPaymentDone.ongoingPayments')}
                      </NavLink>
                      {getText(
                        'payApply.delayedPaymentDone.instructionsAutomaticDebit4',
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'inline-block',
                      marginTop: '50px',
                      width: '100%',
                    }}
                  >
                    <div style={{ float: 'left' }}>
                      <label
                        className={midas.formLabel}
                        style={{
                          font: 'normal normal normal 15px/20px Arial',
                          marginRight: '5px',
                          verticalAlign: 'middle',
                          lineHeight: 2.3,
                        }}
                      >
                        {getText('payApply.delayedPaymentDone.instructions')}
                      </label>
                      <NavLink
                        style={{
                          font: 'normal normal normal 15px/20px Arial',
                          color: '#0DBDEB',
                          lineHeight: 2.3,
                        }}
                        to="/payments/ongoing"
                      >
                        {getText('payApply.delayedPaymentDone.ongoingPayments')}
                      </NavLink>
                    </div>
                  </div>
                )}
              </div>
            </Column>
          </Columns>
        </Container>
      </PageWrapper>
      <PageWrapper>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '2rem',
          }}
        >
          <NavLink to="/apply">
            <Button>{getText('payApply.restart')}</Button>
          </NavLink>
          <Button type="primary" onClick={() => props.onNext()}>
            {getText('payApply.logout')}
          </Button>
        </div>
      </PageWrapper>
    </>
  )
}

DelayedPaymentDonePage.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
}
